module.exports = __webpack_public_path__ + "static/media/platano_crema.d8be6288.png";